/**
 * Constants used throughout the Recording components
 */

// Logger label for all Recording components
export const LOGGER_LABEL = 'RecordingUI';

// Recording timeout settings
export const FRAME_DECODE_TIMEOUT = 5000;

// API endpoints
export const ANALYTICS_API_ENDPOINT = 'https://evx28qqnajzzt.apitraffic.io';

export const BACKGROUND_COLOR = "#273540";
export const SPINNER_COLOR = "#FFF";

export const RECORDING_START_CHECK_INTERVAL = 1000;

export const CANVAS_WIDTH = 1920;
export const CANVAS_HEIGHT = 1080;